function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $625ad1e1f4c43bc1$exports = require("./CalendarDate.main.js");
var $a5090d6430502238$exports = require("./utils.main.js");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "PersianCalendar", function () {
  return $3c060181fc7249ae$export$37fccdbfd14c5939;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.

var $3c060181fc7249ae$var$PERSIAN_EPOCH = 1948320;
// Number of days from the start of the year to the start of each month.
var $3c060181fc7249ae$var$MONTH_START = [0, 31, 62, 93, 124, 155, 186, 216, 246, 276, 306, 336 // Esfand
];
var $3c060181fc7249ae$export$37fccdbfd14c5939 = /*#__PURE__*/function () {
  function $3c060181fc7249ae$export$37fccdbfd14c5939() {
    _classCallCheck(this, $3c060181fc7249ae$export$37fccdbfd14c5939);
    this.identifier = 'persian';
  }
  return _createClass($3c060181fc7249ae$export$37fccdbfd14c5939, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var daysSinceEpoch = jd - $3c060181fc7249ae$var$PERSIAN_EPOCH;
      var year = 1 + Math.floor((33 * daysSinceEpoch + 3) / 12053);
      var farvardin1 = 365 * (year - 1) + Math.floor((8 * year + 21) / 33);
      var dayOfYear = daysSinceEpoch - farvardin1;
      var month = dayOfYear < 216 ? Math.floor(dayOfYear / 31) : Math.floor((dayOfYear - 6) / 30);
      var day = dayOfYear - $3c060181fc7249ae$var$MONTH_START[month] + 1;
      return new (0, $625ad1e1f4c43bc1$exports.CalendarDate)(this, year, month + 1, day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      var jd = $3c060181fc7249ae$var$PERSIAN_EPOCH - 1 + 365 * (date.year - 1) + Math.floor((8 * date.year + 21) / 33);
      jd += $3c060181fc7249ae$var$MONTH_START[date.month - 1];
      jd += date.day;
      return jd;
    }
  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear() {
      return 12;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      if (date.month <= 6) return 31;
      if (date.month <= 11) return 30;
      var isLeapYear = (0, $a5090d6430502238$exports.mod)(25 * date.year + 11, 33) < 8;
      return isLeapYear ? 30 : 29;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AP'];
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      // 9378-10-10 persian is 9999-12-31 gregorian.
      // Round down to 9377 to set the maximum full year.
      return 9377;
    }
  }]);
}();